/* cp-desc.js — la description produit est découpée en titres dépliants.
   Les fiches Shopify contiennent déjà des <h3> : chacun devient un bloc,
   on ne lit plus un pavé de dix paragraphes. */
(function(){
  'use strict';

  var CSS = ''
    + '.plead{margin:20px 0 2px;font-size:14.5px;line-height:1.6;color:#4a5157}'
    + '.plead p{margin:0 0 10px}'
    + '.plead p:last-child{margin-bottom:0}'
    + '.plead strong{color:var(--ink,#101215)}'
    + '@media (max-width:900px){.plead{font-size:14px;margin-top:16px}}';

  function style(){
    if(document.getElementById('cp-desc-css')) return;
    var s = document.createElement('style');
    s.id = 'cp-desc-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function run(){
    var acc = document.querySelector('details.pacc[data-src="desc"]');
    if(!acc) return;
    var rte = acc.querySelector('.pdesc.rte');
    if(!rte) return;
    style();
    if(!rte.querySelector('h2,h3')) return;

    var groups = [], cur = { title:null, nodes:[] };
    [].slice.call(rte.childNodes).forEach(function(n){
      if(n.nodeType === 1 && /^H[23]$/.test(n.tagName)){
        groups.push(cur);
        cur = { title: n.textContent.trim(), nodes: [] };
      }else{
        cur.nodes.push(n);
      }
    });
    groups.push(cur);

    var frag = document.createDocumentFragment();
    groups.forEach(function(g){
      var has = g.nodes.some(function(n){ return (n.textContent || '').trim(); });
      if(!has) return;

      if(!g.title){
        var lead = document.createElement('div');
        lead.className = 'plead rte';
        g.nodes.forEach(function(n){ lead.appendChild(n); });
        frag.appendChild(lead);
        return;
      }

      var d = document.createElement('details');
      d.className = 'pacc';
      var s = document.createElement('summary');
      s.textContent = g.title;
      var b = document.createElement('div');
      b.className = 'pdesc rte';
      g.nodes.forEach(function(n){ b.appendChild(n); });
      d.appendChild(s);
      d.appendChild(b);
      frag.appendChild(d);
    });

    acc.parentNode.insertBefore(frag, acc);
    acc.remove();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
